import { render, staticRenderFns } from "./powerEffect.vue?vue&type=template&id=422e0e91&scoped=true&"
import script from "./powerEffect.vue?vue&type=script&lang=js&"
export * from "./powerEffect.vue?vue&type=script&lang=js&"
import style0 from "./powerEffect.vue?vue&type=style&index=0&id=422e0e91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e0e91",
  null
  
)

export default component.exports